import { style } from "@vanilla-extract/css";
import { vars } from "plos/src/styles";

export const matchContentSkel = style({
  display: "flex",
  flex: 1,
  justifyContent: "center",
});

export const teamAndManagerSkelWrapper = style({
  display: "grid",
  gap: vars.space["2xs"],
});
